import { SingleDataValue } from './SingleDataValue';
import FormatDate from '../../../Utils/Local/FormatDate';
import TranslateTag from '../../../Utils/Local/TranslateTag';
import { ParseColourTag } from './ReportColourParser';

const LINE_SPACING = 4;
const MARGIN_BOTTOM = 7.5;
const DEFAULT_FONT_SIZE = 11;

const writeLinesAndSetPosition = (
    lines,
    pdf,
    data,
    language,
    invertYDirection = false,
    lineSpacing = LINE_SPACING,
    marginBottom = MARGIN_BOTTOM,
    defaultFontSize = DEFAULT_FONT_SIZE
) => {
    const state = writeLines(
        lines,
        pdf,
        data,
        language,
        invertYDirection,
        lineSpacing,
        marginBottom,
        defaultFontSize
    );

    pdf.setCurrentLine(state.currentLine);
    pdf.setCurrentLinePosition(state.currentLinePosition);
};

const writeLines = (
    lines,
    pdf,
    data,
    language,
    invertYDirection = false,
    lineSpacing = LINE_SPACING,
    marginBottom = MARGIN_BOTTOM,
    defaultFontSize = DEFAULT_FONT_SIZE
) => {
    let currentLine = pdf.getCurrentLine();
    let currentLinePosition = pdf.getCurrentLinePosition();

    for (const line of lines) {
        if (currentLine !== line.Line) {
            const fontSize =
                !line.FontSize || line.FontSize === 0
                    ? defaultFontSize
                    : line.FontSize;
            pdf.setFontSize(fontSize);
            if (invertYDirection) {
                currentLinePosition -= pdf.getLineHeight('TestString') + lineSpacing;
            } else {
                currentLinePosition += pdf.getLineHeight('TestString') + lineSpacing;
            }
        }
        writeLine(line, data, pdf, currentLinePosition, language);
        
        currentLine = line.Line;
    }
    if (invertYDirection) {
        currentLinePosition -= pdf.getLineHeight('TestString') + lineSpacing;
    } else {
        currentLinePosition += marginBottom;
    }
    return { currentLinePosition, currentLine };
};

const writeLine = (line, data, pdf, currentLinePos, language) => {
    if (line.FontSize && line.FontSize > 0) {
        pdf.setFontSize(line.FontSize);
    }

    if (line.Text) {
        pdf.text(line.Left, currentLinePos, line.Text);
    } else if (line.Field) {
        let textToDisplay = SingleDataValue(line.Field, data);

        const colourTag = ParseColourTag(textToDisplay);

        if (colourTag) {
            pdf.setTextColor(colourTag.colour);
            textToDisplay = textToDisplay.replace(colourTag.text, '');
        }
        pdf.text(line.Left, currentLinePos, textToDisplay);
        pdf.setTextColor(0, 0, 0);
    } else if (line.Calc) {
        switch (line.Calc.toLowerCase()) {
            case 'printeddate':
                pdf.text(line.Left, currentLinePos, FormatDate(new Date()));
                break;
            case 'pages':
                pdf.text(
                    line.Left,
                    currentLinePos,
                    TranslateTag('@GenPagA@', language) +
                        ' ' +
                        pdf.internal.getCurrentPageInfo().pageNumber +
                        ' ' +
                        TranslateTag('@GenOfA@', language) +
                        ' {total_pages_count_string}'
                );
                break;
            default:
                pdf.text(line.Left, currentLinePos, 'NoDef');
                break;
        }
    }
};

export { writeLinesAndSetPosition as WriteLinesAndSetPosition, writeLine as WriteLine, writeLines as WriteLines };
